module.exports = __webpack_public_path__ + "img/material.699f6709.png";